import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled, { css } from 'styled-components';
import {
  maxBreakpointQuery,
  minBreakpointQuery,
  brandColours,
  standardColours,
  visuallyHidden,
  sectionPaddings,
} from '../styles';
import { Container, Button, Heading, HtmlContent } from './ui';

const StyledNewsletterSignup = styled.section`
  background-color: ${brandColours.secondary};

  ${({ isPopup }) => {
    if (!isPopup) {
      return css`
        ${sectionPaddings()};
      `;
    }
  }};
`;

const StyledContainer = styled(Container)`
  ${({ isPopup }) => {
    if (isPopup) {
      return css`
        padding: 0;
      `;
    }
  }};
`;

const StyledInner = styled.div`
  color: ${standardColours.white};
  display: grid;
  gap: 30px;
  align-items: center;

  ${minBreakpointQuery.small`
    gap: 35px;
  `}

  ${minBreakpointQuery.medium`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${minBreakpointQuery.large`
    gap: 40px;
  `}

  ${({ isPopup }) => {
    if (isPopup) {
      return css`
        ${minBreakpointQuery.medium`
          grid-template-columns: repeat(1, 1fr);
        `}
      `;
    }
  }};
`;

const StyledText = styled(HtmlContent)`
  margin-top: 20px;
`;

const StyledSignupForm = styled.form`
  display: flex;
  gap: 30px;
  align-items: center;

  ${maxBreakpointQuery.small`
    justify-items: center;
    flex-direction: column;
  `}

  ${minBreakpointQuery.small`
    display: flex;
    gap: 15px;
    align-items: center;
  `}
`;

const StyledLabel = styled.label`
  width: 100%;

  span {
    ${visuallyHidden()}
  }
`;

const StyledInput = styled.input`
  background-color: ${standardColours.white};
  border-radius: 3px;
  width: 100%;
  padding: 20px;
  border: none;
`;

const StyledButton = styled(Button)`
  width: 100%;
  max-width: 160px;
  background-color: ${brandColours.primary};
`;

const NewsletterSignup = ({ heading, text, isPopup, closePopup, ...props }) => {
  const {
    datoCmsNewsletterSignUp: { sitewideHeading, sitewideText },
  } = useStaticQuery(graphql`
    query NewsletterSignupQuery {
      datoCmsNewsletterSignUp {
        sitewideHeading: heading
        sitewideText: text
      }
    }
  `);

  return (
    <StyledNewsletterSignup isPopup={isPopup} {...props}>
      <StyledContainer isPopup={isPopup}>
        <StyledInner isPopup={isPopup}>
          <header>
            <Heading>{heading || sitewideHeading}</Heading>
            <StyledText html={text || sitewideText} />
          </header>
          <StyledSignupForm
            action="https://charitylog.us16.list-manage.com/subscribe/post?u=02287421a757e1f1c36de61a0&amp;id=24d44bfd57&amp;v_id=3608&amp;f_id=00ef7fe0f0"
            method="post"
            name="mc-embedded-subscribe-form"
            target="_blank"
          >
            <StyledLabel>
              <span>Email</span>
              <StyledInput
                type="email"
                name="EMAIL"
                placeholder="Enter your e-mail here"
                required
              />
            </StyledLabel>
            <input type="hidden" name="tags" value="3735484,3736132,3735488" />
            <StyledButton type="submit" onClick={() => closePopup()}>
              Sign up
            </StyledButton>
          </StyledSignupForm>
        </StyledInner>
      </StyledContainer>
    </StyledNewsletterSignup>
  );
};

export default NewsletterSignup;
